import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssistant = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M4.10957 0.927664C5.70642 -0.102769 8.07773 -0.218229 10.0308 0.303522C11.8389 0.786061 13.3443 2.19011 13.8333 3.89697C14.1111 4.8664 14.1144 5.88594 13.9466 6.88369C13.8333 7.55794 13.683 8.24744 13.805 8.93367C14.1176 10.6852 15.1622 12.1785 15.0805 13.8887C14.9084 17.5061 10.3619 18.6084 6.99283 16.8504C6.46672 16.5759 5.99943 16.2654 5.52451 15.9027C4.1978 14.8886 3.78606 13.9148 3.68803 12.8713C3.58564 11.7755 3.83943 10.6046 3.63683 9.2038C3.54207 8.54807 3.27629 7.91522 3.01596 7.30306C2.67393 6.50028 2.46044 5.67462 2.40706 4.80976C2.31666 3.35234 2.77959 1.78491 4.10848 0.927664H4.10957Z",
			fill: "url(#paint0_radial_10242_186)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M11.086 3.80582C11.5359 4.11952 11.9312 4.31563 12.4879 4.61513C13.2485 5.02436 13.7264 5.15481 14.4768 5.58239L14.4899 5.58981C15.0324 5.8989 15.4429 6.13281 15.8428 6.44944C16.3417 6.84374 16.7469 7.29578 17.0725 7.87418C17.9505 9.43508 17.139 11.167 15.9016 12.4153C14.5705 13.7572 12.88 14.6951 11.1644 15.2136C9.57193 15.695 7.96746 15.7037 6.52419 15.2397C4.84565 14.7005 3.36862 13.5274 2.40463 11.6626C1.74345 10.3827 1.3633 8.81965 1.3132 7.26311C1.27616 6.14118 1.40687 5.02796 1.70097 4.03021C2.09311 2.69587 2.77607 1.56196 3.78363 0.92257C5.05479 0.115434 6.51875 0.389925 7.76377 1.17419C8.18531 1.43996 8.58724 1.74496 8.97829 2.07173C9.6765 2.65339 10.3497 3.29169 11.086 3.80582Z",
			fill: "url(#paint1_linear_10242_186)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M2.61425 15.2495C3.734 16.2113 4.63828 16.5472 6.00094 16.4862C6.91264 16.4459 7.72958 16.1496 8.65 16.0015C9.49635 15.8653 10.3721 15.8947 11.2108 15.837C12.9547 15.7172 15.2182 14.2184 16.2813 13.0921C17.4447 11.859 18.3967 9.4104 17.8335 7.18724C17.2224 4.77454 15.2552 2.81062 14.5178 2.30194C13.3 1.46213 10.5693 0.0842214 7.18605 0.905518C6.20245 1.14406 4.25704 2.38036 3.72003 3.0252C2.64385 4.31597 2.04149 5.85617 1.47508 7.45519C0.977291 8.85815 0.578623 10.4027 0.850937 11.9854C1.07532 13.2838 1.64372 14.4152 2.61425 15.2495Z",
			fill: "url(#paint2_radial_10242_186)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .7,
			d: "M6.18583 4.1679C4.39074 5.20596 2.22748 5.29419 0.796196 7.15245C-1.07405 9.79389 0.450903 13.1717 4.31885 13.7152C7.18032 14.0376 11.8097 17.9426 14.9195 15.6911C16.0719 14.8339 15.9205 13.3557 15.8029 11.0857C15.7157 9.41265 16.3181 8.21665 16.4063 6.72764C16.7494 3.00785 14.2148 0.544651 11.5461 0.762504C8.87743 0.980357 7.67702 3.30739 6.18583 4.1679Z",
			fill: "url(#paint3_linear_10242_186)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8651 9.33533C12.4066 8.03258 11.7084 6.8246 10.8097 5.77565C9.81088 4.61015 7.98746 4.61015 6.98971 5.77565C6.09216 6.82351 5.39395 8.03258 4.93537 9.33533C4.42451 10.784 5.3384 12.3624 6.84919 12.6445C8.20423 12.8972 9.59738 12.8972 10.9524 12.6445C12.4621 12.3624 13.3771 10.784 12.8662 9.33533H12.8651Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_10242_186",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "matrix(4.84719 -13.8335 8.81914 3.09016 8.71383 14.7594)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#7DC7F1" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D9ECBE"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_10242_186",
				x1: 4.4659,
				y1: 3.81229,
				x2: 15.8486,
				y2: 10.13,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#20C4DB" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACDFDF"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint2_radial_10242_186",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "matrix(-12.472 6.75336 -7.34938 -13.5726 14.5416 9.69434)",
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#7DC7F1" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .215953,
						stopColor: "#7DC7F1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .46018,
						stopColor: "#7DC7F1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .714675,
						stopColor: "#D9ECBE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#D9ECBE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_10242_186",
				x1: 13.5612,
				y1: 4.84758,
				x2: 4.57483,
				y2: 10.8385,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#005AFF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#32C8DC"
				})]
			})
		] })
	]
});
export default SvgAssistant;
